<template>
  <MovimentCheckLayout
      title="Saída"
      titleIcon="fa-solid fa-clipboard-check"
      :loading="loading"
      :totalItems="content.items ? content.items.length : 0"
      :successMoviment="successMoviment"
      loadingText="Aguarde, estamos preparando a saída..."
      qtyColumnLabel="Saída"
  >
    <template #success>
      <SuccessMoviment v-if="successMoviment" :rentId="rentId" :movimentId="movimentId"
                       msgSuccess="Saída processada com sucesso!"/>
    </template>

    <template #extra-th>
      <th class="mcl-th-center">Estoque</th>
    </template>

    <template #rows>
      <tbody v-for="item in content.items" :key="item.productId || item.productFullName">
      <tr class="mcl-tr">
        <td class="mcl-td-product">{{ item.productFullName }}</td>
        <td>
          <div class="mcl-td-desc">
            <InputTextEdit v-model="item.description"/>
          </div>
        </td>
        <td class="mcl-th-center">
          <span class="mcl-qty-badge mcl-qty-badge--rent">{{ item.totalRent }}</span>
        </td>
        <td class="mcl-th-center">
          <span class="mcl-qty-badge mcl-qty-badge--return">{{ item.totalSelected }}</span>
        </td>
        <td class="mcl-th-center">
          <i v-if="item.typeProduct == 3" class="fas fa-people-carry"></i>
          <ItemRentStockAvailability v-if="item.typeProduct != 3" :data="item.available" :item="item"
                                     :showButtonBack="false"/>
        </td>
        <td class="mcl-th-center">
            <span v-if="!hasProductInStock(item)" class="mcl-status mcl-status--danger">
              <i class="fa-solid fa-brake-warning"></i>
            </span>
          <span v-else-if="item.totalSelected > item.totalRent" class="mcl-status mcl-status--primary">
              <i class="fa-solid fa-rectangle-history-circle-plus"></i>
            </span>
          <span v-else-if="item.totalSelected == item.totalRent" class="mcl-status mcl-status--success">
              <i class="fa-solid fa-circle-check"></i>
            </span>
          <span v-else-if="item.totalSelected < item.totalRent && item.totalSelected != 0"
                class="mcl-status mcl-status--warning">
              <i class="fa-solid fa-triangle-exclamation"></i>
            </span>
          <span v-else-if="item.totalSelected == 0" class="mcl-status mcl-status--danger">
              <i class="fa-solid fa-do-not-enter"></i>
            </span>
        </td>
      </tr>
      <tr v-if="item.patrimony.length > 0" class="mcl-tr-patrimony">
        <td colspan="100" class="mcl-td-patrimony">
          <div v-for="patrimony in sortedPatrimony(item.patrimony)" :key="patrimony.barCode" class="mcl-patrimony-row">
            <PatrimonyBadge :barCode="patrimony.barCode"/>
          </div>
        </td>
      </tr>
      </tbody>
    </template>

    <template #alerts>
      <Alert type="danger" v-if="isStockNegative" style="margin-top:14px;">
        <span>Não é permitido saída de estoque negativo. Verifique e ajuste os produtos em falta.</span>
      </Alert>
      <Alert type="danger" v-if="generateError" style="margin-top:14px;">
        <span>Ocorreu um erro ao processar a saída. Verifique e ajuste.</span>
      </Alert>
      <div class="div-after-before" v-if="content.invalidPeriod && !content.isAdjustDeliveryDate">
        <Alert type="warning">
          O <b>Período de Locação</b> contém data anterior a hoje e não é permitido! Ajuste as datas para continuar ou
          <span class="discard-link" @click="confirmDiscard"> CLIQUE AQUI </span> para manter o Período de Atual.
        </Alert>
      </div>
    </template>

    <template #actions>
      <slot></slot>
      <Button _key="btnGenerateOutput" type="success"
              :disabled="isStockNegative || content.invalidPeriod" title="Gerar Saída"
              classIcon="fa-solid fa-circle-check" size="large" :clicked="generate"/>
    </template>

    <template #modals>
      <Modal title="Painel" :width="1000" v-if="showModal('timeLineAvailability')">
        <TimeLineAvailability/>
      </Modal>

      <Modal title="Alerta" v-if="content.isAdjustDeliveryDate" :width="900" :closeOnEsc="false" :closeButton="false">
        <Warning title="ATENÇÃO" periodRent="Manter o período atual"
                 :periodRentReturn="'Atualizar saída para ' + content.deliveryPeriodBeforeOrAfterStr"
                 @confirm="confirm">
          <div class="title">A data de <b>SAÍDA</b> está ocorrendo fora do prazo previsto, selecione o período correto
            para continuar!
          </div>
        </Warning>
      </Modal>
    </template>
  </MovimentCheckLayout>
</template>

<script>
import MovimentCheckLayout from "../shared/MovimentCheckLayout.vue";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";
import Modal from "@nixweb/nixloc-ui/src/component/forms/Modal";
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import InputTextEdit from "@nixweb/nixloc-ui/src/component/forms/InputTextEdit.vue";
import Warning from "../Warning.vue";
import SuccessMoviment from "../SuccessMoviment.vue";
import TimeLineAvailability from "../../shared/TimeLineAvailability.vue";
import ItemRentStockAvailability from "../../../rental/items-rent/ItemRentStockAvailability.vue";
import PatrimonyBadge from "../shared/PatrimonyBadge.vue";

import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "CheckOutput",
  components: {
    MovimentCheckLayout,
    Button,
    Modal,
    Alert,
    InputTextEdit,
    ItemRentStockAvailability,
    TimeLineAvailability,
    SuccessMoviment,
    Warning,
    PatrimonyBadge,
  },
  props: {
    rentId: String,
  },
  data() {
    return {
      urlCheck: "/api/v1/moviment/generate-output/check-output",
      urlGenerate: "/api/v1/moviment/generate-output/generate",
      content: [],
      loading: true,
      successMoviment: false,
      movimentId: "",
      generateError: false,
    };
  },
  mounted() {
    this.checkOutput();
  },
  computed: {
    ...mapGetters("generic", ["showModal"]),
    ...mapGetters("generateMoviment", ["productSelectedByPeriod"]),
    ...mapState("user", ["userLogged"]),
    ...mapState("generateMoviment", ["periodRent", "productRent"]),
    isStockNegative() {
      if (this.content.isStockNegative && !this.userLogged.parameterStock.allowNegative)
        return true;
      return false;
    },
  },
  methods: {
    ...mapActions("generic", ["postApi"]),
    ...mapMutations("generic", ["removeLoading", "openModal", "hideModal"]),
    ...mapMutations("generateMoviment", ["cleanProductSelected"]),
    hasProductInStock(item) {
      if (item.available.totalStock >= item.totalSelected) return true;
      if (item.available.totalStock < item.totalSelected) return false;
    },
    checkOutput() {
      let obj = {
        periodRent: this.periodRent.fullPeriod,
        productRent: this.productRent,
        productSelected: this.productSelectedByPeriod,
      };
      let params = {url: this.urlCheck, obj: obj, notNotifyToast: true};
      this.postApi(params).then((response) => {
        if (response.success) {
          this.content = response.content;
          if (this.content.deliveryPeriodBeforeOrAfter || this.content.invalidPeriod) this.openModal("alert");
        }
        this.loading = false;
      });
    },
    generate() {
      this.loading = true;
      this.generateError = false;
      let obj = {
        periodRentId: this.periodRent.id,
        rentId: this.rentId,
        isAdjustDeliveryDate: this.content.isAdjustDeliveryDate,
        items: this.content.items,
      };
      let params = {url: this.urlGenerate, obj: obj, notNotifyToast: false};
      this.postApi(params).then((response) => {
        if (response.success) {
          this.movimentId = response.content;
          let self = this;
          setTimeout(function () {
            self.successMoviment = true;
            self.loading = false;
            self.cleanProductSelected();
            self.removeLoading(["btnGenerateOutput"]);
          }, 300);
        } else {
          this.removeLoading(["btnGenerateOutput"]);
          this.loading = false;
          this.generateError = true;
        }
      });
    },
    confirm(option) {
      if (option == "periodRent") this.discard();
      if (option == "newPeriod") {
        this.content.isAdjustDeliveryDate = false;
        this.hideModal();
      }
    },
    confirmDiscard() {
      this.openModal("discard");
    },
    discard() {
      this.hideModal();
      this.removeLoading(["confirm"]);
      this.content.deliveryPeriodBeforeOrAfter = null;
      this.content.isAdjustDeliveryDate = false;
      this.content.invalidPeriod = false;
    },
    ok() {
      this.hideModal();
      this.removeLoading(["btnOk"]);
    },
    sortedPatrimony(patrimonies) {
      return [...patrimonies].sort((a, b) => (a.barCode || '').localeCompare(b.barCode || ''));
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "timeLineAvailability") {
          this.openModal("timeLineAvailability");
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 15px;
}

.div-after-before {
  margin-top: 14px;
  margin-bottom: 10px;
}

.discard-link {
  font-size: 15px;
  color: #1f53e4;
  cursor: pointer;
  font-weight: 700;
}
</style>